import React, { useState } from 'react';
import Input from '@material-ui/core/Input';
import {useDispatch, useSelector} from 'react-redux';

import { authRoute } from '~/routes'
import InputControl from '~/components/Input/InputControl';

import { resetPasswordRequest } from '~/store/modules/resetPassword';

import {
  Container,
  BackgroundColorAbsolute,
  ContainerLogin,
  Logo,
  Button
} from './styles';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const dispatch = useDispatch();
  const loading = useSelector(state => state.resetPassword.loading);

  function handleSubmit(event) {
    event.preventDefault();
    dispatch(resetPasswordRequest(password, passwordConfirmation));
  }

  return (
    <Container>
      <BackgroundColorAbsolute />
      <ContainerLogin>
        <form onSubmit={handleSubmit}>
          <Logo />
          <InputControl
            name="password"
            label="Informe sua nova senha *"
            value={password}
            inputComponent={Input}
            InputProps={{ type: 'password' }}
            onChange={(value) => setPassword(value.password)}
          />

          <div>
            <InputControl
              name="passwordConfirmation"
              label="Confirme sua nova senha *"
              value={passwordConfirmation}
              inputComponent={Input}
              InputProps={{ type: 'password' }}
              onChange={(value) => setPasswordConfirmation(value.passwordConfirmation)}
            />
            <a href={authRoute.signIn.build()}>Login</a>
          </div>



          <Button
            disabled={loading}
            type="submit"
            variant="contained"
            color="green"
          >
            Salvar
          </Button>
        </form>
      </ContainerLogin>
    </Container>
  );
}
